/**
 * @format
 */

import { Injectable } from "@angular/core";
import { LinkTextUrlType } from "../types/link-text-value.type";
import { Subject } from "rxjs/index";
import { document } from "ngx-bootstrap/utils";

@Injectable({
   providedIn: "root",
})
export class LinkToolService {
   onLinkModalClose$: Subject<LinkTextUrlType>;

   constructor() {
      this.onLinkModalClose$ = new Subject<LinkTextUrlType>();
   }

   getAElementAsInnerHTML(link: LinkTextUrlType): string {
      const spanElement: HTMLSpanElement = document.createElement("SPAN");
      spanElement.contentEditable = "false";

      const anchorElement: HTMLAnchorElement = document.createElement("A");
      anchorElement.className = "editor__link";
      anchorElement.innerText = link.text;

      const anchorElementWithLink = this.retrieveAnchorWithLink(anchorElement, link.isConfirmLink, link.url);

      const anchorAndStyle = `<style>
                            .editor__link{
                                color: #337ab7 !important;
                                text-decoration: none;
                            }
                            .editor__link:hover{
                                text-decoration: underline;
                            }
                            </style>
                            ${anchorElementWithLink.outerHTML}`;

      spanElement.innerHTML = anchorAndStyle;

      return spanElement.outerHTML;
   }

   private retrieveAnchorWithLink(
      anchorElement: HTMLAnchorElement,
      isConfirm: boolean,
      linkUrl: string
   ): HTMLAnchorElement {
      if (!isConfirm) {
         anchorElement.href = linkUrl;
         return anchorElement;
      }

      anchorElement.setAttribute(
         "th:attr",
         "href='$$$gateway.action(email,confirm,' + ${appointment.appointmentId} + ',' + ${appointment.appointmentTime} + ')$$$'"
      );
      return anchorElement;
   }
}
